import React, {useState} from "react";
import { ErrMessage, MinLoader, modalsStyle} from "components";
import { ErrorText, useGlobalTextStyles, useModal } from 'utils';
import {loadsStyle} from "../styles";
import {loadAuthActions} from "store";

export const CsvModal = ({dataForFilter}) => {
    const classes = modalsStyle()
    const customClass = loadsStyle()
    const globalText = useGlobalTextStyles();
    const [error, setError] = useState('')
    const [loader, setLoader] = useState(false)
    const [inputs, setInputs] = useState('')
    const { close } = useModal();

    const handleExport = async () => {
        if (inputs?.from) {
            setLoader(true)
            try {
                const date = dataForFilter ?  {
                    from: new Date(inputs?.from),
                    ...dataForFilter,
                } : {
                    from: new Date(inputs?.from),
                }

                inputs?.to ? date.to = new Date(inputs?.to) : ''

                const response = await loadAuthActions.getReceivablesInfoService(date)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `file.csv`);
                document.body.appendChild(link);
                link.click();
                setLoader(false)
                close()
            } catch (err) {
                if (err?.data?.message === 'Load was not found') {
                    setError('Load was not found')
                }
                setLoader(false)
            }
        } else {
            setError('notField')
        }
    }

    const handleSelectDate = (e) => {
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value,}),);
        setError('')
    }

    return (
        <div className={classes.loadCsvModal}>
            <div>
                <p className={globalText.modalTitle}>{'Export Date Range'}</p>
                <p className={globalText.modalText}>
                    {'All data within the selected date range.'}
                </p>
                <div className={customClass.inputAndButton}>
                    <div className={customClass.inputWrapper}>
                        <p>Choose start month</p>
                        <input
                            name={'from'}
                            style={error ? {borderColor: '#F07379'} : {}}
                            onChange={handleSelectDate}
                            className={customClass.exportCsvDate}
                            type={'month'}
                        />
                        <ErrMessage text={
                            error === 'notField' ? ErrorText.field :
                                error === 'Load was not found' ? 'Sorry but we don’t have load data for this month!' :
                                    ''}
                        />
                    </div>

                    <div style={{marginLeft: '8px'}} className={customClass.inputWrapper}>
                        <p>Choose end month</p>
                        <input
                            name={'to'}
                            style={error ? {borderColor: '#F07379'} : {}}
                            onChange={handleSelectDate}
                            className={customClass.exportCsvDate}
                            type={'month'}
                        />
                    </div>

                </div>

                <div className={customClass.customClassWrapper}>
                    <button onClick={handleExport} className={customClass.exportButton}>
                        {loader ?
                            <MinLoader position={'relative'} color={'white'}/>
                            :
                            'Export CSV'
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}